export const VAULT_KYC_CREATE_QUERY = `mutation VaultKycCreate(
  $rawKycAddress: VaultAddressInput!,
  $rawKycDob: VaultDobInput!,
  $rawKycEmail: String!,
  $rawKycFirstName: String!,
  $rawKycLastName: String!,
  $rawKycPhoneNumber: String!,
  $rawKycSsn: String,
  $title: String,
  $percentOwnership: Int,
  $director: Boolean,
  $executive: Boolean,
  $owner: Boolean,
  $representative: Boolean) {
    kycId: vaultKycCreate(
      address: $rawKycAddress,
      dob: $rawKycDob,
      email: $rawKycEmail,
      firstName: $rawKycFirstName,
      lastName: $rawKycLastName,
      phoneNumber: $rawKycPhoneNumber,
      ssn: $rawKycSsn,
      director: $director,
      executive: $executive,
      owner: $owner,
      representative: $representative,
      percentOwnership: $percentOwnership,
      title: $title
    )
}`;

export const VAULT_ORG_CONFIRMATION_WITH_CREATE_KYC_QUERY = `mutation VaultOrgConfirmationSubmit(
$gateway: VaultFinancialProvider!,
$orgData: VaultFormKybInput!,
$rawRepresentativeData: VaultRepresentativeCreateInput!,
$submittedOnYourBehalf: Boolean!,
$stripeData: VaultFormStripeInput,
$representativeToReplace: VaultRepresentativeCreateInput,
$bankAccountPayableOrgId: ID,
$fundraiserId: String,
$fundraiserSlug: String,
$productDescription: String,
$rawBeneficialOwners: [VaultBeneficialOwnerCreateInput!]) {
  vaultOrgConfirmationSubmit(
  gateway: $gateway,
  orgData: $orgData,
  primaryRepresentative: $rawRepresentativeData,
  submittedOnYourBehalf: $submittedOnYourBehalf,
  stripeData: $stripeData,
  representativeToReplace: $representativeToReplace,
  bankAccountPayableOrgId: $bankAccountPayableOrgId,
  fundraiserId: $fundraiserId,
  fundraiserSlug: $fundraiserSlug,
  productDescription: $productDescription,
  beneficialOwners: $rawBeneficialOwners) {
    success
    errors {
      details
      field
      fieldMessage
      retryable
      message
      type
    }
    successData {
      beneficialOwners {
        kycId
        stripePersonId
        userId
      }
      kybData {
        financialAccountId
        kybId
        metadata {
          activityType
          entity
          fundraiserId
          paymentType
          transactionId
          fundraiserId_legacy
        }
        orgId
        stripeConnectAccountId
      }
      payableOrgNode {
        beneficialOwners {
          kycId
          stripePersonId
          userId
        }
        kybData {
          financialAccountId
          kybId
          metadata {
            activityType
            entity
            fundraiserId
            paymentType
            transactionId
            fundraiserId_legacy
          }
          orgId
          stripeConnectAccountId
        }
        representative {
          kycId
          stripePersonId
          userId
        }
      }
      representative {
        kycId
        stripePersonId
        userId
      }
      stripeEnv
    }
  }
}`;
